import React from 'react';
import { Link } from 'react-router';
import cx from 'classnames';
import type { WPublicNavItemView } from '@zola/svc-web-api-ts-client';
import PublicPagesNav from './PublicPagesNav';
import HeaderCart from './HeaderCart';
import type {
  WebsiteDatePublicPropType,
  WebsiteExactDateType,
  WebsiteDateRangeType,
} from '../../util/websiteDateUtil';
import { WeddingDateDisplayFormatEnum } from '../../util/websiteDateUtil';

type PublicHeaderProps = {
  name?: string;
  weddingDate?: string;
  hashtag?: string;
  location?: string;
  slug?: string;
  pages: Array<WPublicNavItemView>;
  cartSize?: number;
  websiteDate?: WebsiteDatePublicPropType<string>;
};

const PublicHeader = ({
  name,
  weddingDate,
  hashtag,
  location,
  slug,
  pages,
  cartSize,
  websiteDate,
}: PublicHeaderProps): JSX.Element => {
  const className = cx('hashtag', {
    'hashtag--with-cart': cartSize && cartSize > 0,
  });

  // Handles multiple formats
  const renderWeddingDate = () => {
    if (!weddingDate) {
      return null;
    }
    if (websiteDate) {
      const { displayFormat } = websiteDate;
      if (displayFormat === WeddingDateDisplayFormatEnum.EXACT) {
        return (
          <h5 className="wedding-date">
            {(websiteDate as WebsiteExactDateType<string>).weddingDate}
          </h5>
        );
      }
      if (displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
        return (
          <h5 className="wedding-date">
            {(websiteDate as WebsiteDateRangeType<string>).weddingDateRangeStart} -{' '}
            {(websiteDate as WebsiteDateRangeType<string>).weddingDateRangeEnd}
          </h5>
        );
      }
      // No date for custom message
    }
    return null;
  };

  return (
    <header id="public-page-header" className="clearfix">
      <div id="public-page-details" className="top-row hidden-xs hidden-sm">
        {renderWeddingDate()}
        {location && <h5 className="wedding-location">{location}</h5>}
        {hashtag && <h5 className={className}>#{hashtag}</h5>}
      </div>
      <div className="col-xs-12 website-title">
        <h1 id="public-page-title" className="hidden visible-md visible-lg">
          <Link to={`/wedding/${slug}`}>{name}</Link>
        </h1>
        <PublicPagesNav pages={pages} slug={slug} />
        <h1 className="hidden visible-xs visible-sm">
          <Link to={`/wedding/${slug}`}>{name}</Link>
        </h1>
        <HeaderCart cartSize={cartSize} classNames="hidden-md hidden-lg" />
      </div>
    </header>
  );
};

export default PublicHeader;
